export const initialState = () => ({
  offers: [
    {
      value: ""
    }
  ]
})
